export type VoiceGender = 'female' | 'male' | 'other';

export function normalizeVoiceGender(g?: string | null): VoiceGender {
  const s = (g || '').toLowerCase();
  if (s === 'female' || s === '女' || s.includes('female') || s.includes('woman')) return 'female';
  if (s === 'male' || s === '男' || s.includes('male') || s.includes('man')) return 'male';
  return 'other';
}

export function groupVoicesByGender<T extends { gender?: string | null }>(voices: T[]) {
  const female: T[] = [];
  const male: T[] = [];
  const other: T[] = [];
  for (const v of voices) {
    const g = normalizeVoiceGender(v.gender);
    if (g === 'female') female.push(v);
    else if (g === 'male') male.push(v);
    else other.push(v);
  }
  return { female, male, other };
}
